module.exports = __webpack_public_path__ + "assets/img/tennat_info_img.d392978b.png";